
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dailyReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateStrTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateStrFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeDTOInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dailyReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateStrFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStrFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateStrTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStrTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"employee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employee"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateStr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employee"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extraOrdinaryHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ordinaryHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"layoffHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"van"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activitiesHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nightHours"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":405}};
    doc.loc.source = {"body":"query dailyReports ($dateStrTo: String!, $dateStrFrom: String!, $employee: EmployeeDTOInput ) {\n  dailyReports( dateStrFrom: $dateStrFrom, dateStrTo: $dateStrTo, employee: $employee) {\n    dateStr\n    employee {\n      id\n      name\n    }\n\treport {\n      totalHours\n      extraOrdinaryHours\n      ordinaryHours\n      layoffHours\n      allowance\n      van\n      activitiesHours\n      nightHours\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["dailyReports"] = oneQuery(doc, "dailyReports");
        
